const header = document.querySelector('.product-selector__header span');
const items = document.querySelectorAll('.product-selector__item');

const originalText = header.textContent;

items.forEach(item => {
    item.addEventListener('mouseenter', () => {
        const flavorName = item.getAttribute('data-value');
        header.textContent = `Martini Flavor: ${flavorName}`;
    });
    
    item.addEventListener('mouseleave', () => {
        header.textContent = originalText;
    });
});